export default __webpack_public_path__ + "static/media/title-option.71b9e5ca.png";